// extracted by mini-css-extract-plugin
export default {"WorkAboutContainer":"WorkAbout_WorkAboutContainer__JEi0M"};